module.exports = "<div id=\"story_comments\" ng-controller=\"StoryCommentsController\"></div>";